<template>
    <message-bubble
        :is-mine="isMine"
        :message="message"
    >
        <div class="custom-element-wrapper">
            <span
                class="text"
                :title="$t('您可以自行解析自定义消息')"
            >
                <!-- <template v-if="text.isFromGroupLive && text.isFromGroupLive === 1">
                    <message-group-live-status :live-info="text" />
                </template>
                <template v-else>{{ text }}</template> -->
                {{ text }}
            </span>
        </div>
    </message-bubble>
</template>

<script>
import MessageBubble from '../MessageBubble.vue'
// import MessageGroupLiveStatus from '../message-group-live-status'

export default {
    name: 'CustomElement',
    components: {
        MessageBubble
        // MessageGroupLiveStatus
    },
    props: {
        payload: {
            type: Object,
            required: true
        },
        message: {
            type: Object,
            required: true
        },
        isMine: {
            type: Boolean
        }
    },
    computed: {
        text() {
            return this.translateCustomMessage(this.payload)
        }
    },
    methods: {
        translateCustomMessage(payload) {
            let videoPayload = {}
            try {
                videoPayload = JSON.parse(payload.data)
            } catch (e) {
                videoPayload = {}
            }
            if (payload.data === 'group_create') {
                return `${payload.extension}`
            }
            if (videoPayload.roomId) {
                videoPayload.roomId = videoPayload.roomId.toString()
                videoPayload.isFromGroupLive = 1
                return videoPayload
            }
            if (payload.text) {
                return payload.text
            } else {
                return this.$t('[自定义消息]')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.text {
    font-weight: bold;
}
.title {
    font-size: 16px;
    font-weight: 600;
    padding-bottom: 10px;
}
.survey {
    background-color: white;
    color: black;
    padding: 20px;
    display: flex;
    flex-direction: column;
}
.suggestion {
    padding-top: 10px;
    font-size: 14px;
}
</style>
